import Pagination from "../../../components/pagination/Pagination";
import connect from "react-redux/es/connect/connect";
import { getPdcs } from "../../../redux/actions/pdcActions";
const mapStateToProps = state => {
  return {
    page: state.pdcs ? state.pdcs.page : null,
    pages: state.pdcs ? state.pdcs.pages : null,
    pageSize: state.pdcs ? state.pdcs.pageSize : null,
    nbItems: state.pdcs && Array.isArray(state.pdcs.pdcsList) ? state.pdcs.pdcsList.length : null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getNext: page => {
      const nextPage = page;
      dispatch(getPdcs({ page: nextPage }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pagination);



// WEBPACK FOOTER //
// src/containers/metier/pdcs/PaginationContainer.js